import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthService } from './auth.service';
import { Version } from '../_models/version';

@Injectable({
  providedIn: 'root'
})
export class VersionService {
  private static readonly EN_REPLACEMENTS: Record<string, string> = {
    'base de données': 'Database',
    janvier: 'January',
    février: 'February',
    mars: 'March',
    avril: 'April',
    mai: 'May',
    juin: 'June',
    juillet: 'July',
    août: 'August',
    septembre: 'September',
    octobre: 'October',
    novembre: 'November',
    décembre: 'December'
  };

  private static readonly EN_PATTERN = new RegExp(
    Object.keys(VersionService.EN_REPLACEMENTS)
      .map((key) => (key.includes(' ') ? key : `\\b${key}\\b`))
      .join('|'),
    'gi'
  );

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private translate: TranslateService
  ) {}

  getAll() {
    return this.http.get<Version[]>(`${environment.apiUrl}/Versions`, { headers: this.authService.headers }).pipe(map((versions) => (versions ?? []).map((version) => ({ ...version, versionName: this.localizeVersionName(version.versionName) }))));
  }

  private localizeVersionName(name?: string): string | undefined {
    if (!name || this.translate.currentLang !== 'en') return name;
    return name.replace(VersionService.EN_PATTERN, (match) => VersionService.EN_REPLACEMENTS[match.toLowerCase()] ?? match);
  }
}
